module.exports = __webpack_public_path__ + "img/contact.97333df2.svg";